import React, { useState } from 'react';
import emailjs from 'emailjs-com';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    tel: '',
    message: ''
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.tel) {
      alert('number is required.');
      return;
    }


    emailjs.sendForm('service_8vockx8', 'template_1jxjmsh', e.target, 'jNZT47WVzJyjAHFSA')
      .then((result) => {
        alert('Form submitted successfully!');
        setFormData({ name: '', email: '', tel: '', message: '' });
      }, (error) => {
        console.error('Error:', error.text);
        alert('Form submission failed.');
      });
  };

  return (
    <form className="bg-white p-6 shadow-md rounded-lg" onSubmit={handleSubmit}>
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="name">
          שם
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="name"
          type="text"
          placeholder="הכנס את שמך"
          dir="rtl"
          value={formData.name}
          onChange={handleChange}
          name="name"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
          אימייל
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="email"
          type="email"
          placeholder="הכנס את האימייל שלך"
          dir="rtl"
          value={formData.email}
          onChange={handleChange}
          name="email"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="tel">
          טלפון
        </label>
        <input
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="tel"
          type="tel"
          placeholder="הכנס את המספר טלפון שלך"
          dir="rtl"
          value={formData.tel}
          onChange={handleChange}
          name="tel"
        />
      </div>
      <div className="mb-4">
        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="message">
          הודעה
        </label>
        <textarea
          className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          id="message"
          placeholder="הקלד את הודעתך"
          rows="4"
          dir="rtl"
          value={formData.message}
          onChange={handleChange}
          name="message"
        ></textarea>
      </div>
      <div className="flex items-center justify-between">
        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
          שלח
        </button>
      </div>
    </form>
  );
};

export default ContactForm;